import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

// The whole site is dark ("teal + apricot"), so Vuetify's own components
// (dialogs, inputs, menus, snackbars) use the dark theme with ember accents.
export default new Vuetify({
  theme: {
    dark: true,
    options: { customProperties: true },
    themes: {
      dark: {
        primary: '#F4A259',
        secondary: '#F7C28F',
        accent: '#EE8A4E',
        error: '#F06A6E',
        warning: '#F7C28F',
        info: '#8FA9AB',
        success: '#4ADE80',
        background: '#0D2226',
        surface: '#122D32'
      }
    }
  }
});
